import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Box
} from "@mui/material";
import { PacsEnrolment } from "../../../../../../utils/EnrolmentTypeUtility";

//use for PACS client
const DeclarationModal = ({ open, onClose, onSubmit, user }) => {
  const dependencies = user?.dependencies || [];
  const childDependencies = dependencies.filter(
        dep => dep.dependent?.toUpperCase() === "CHILD" &&
        PacsEnrolment.isChildBetween18And25(dep.dob)
      );
  console.log("childDependencies", childDependencies);
  const [eligibility, setEligibility] = useState("");
  const [undertaking, setUndertaking] = useState(false);
  const [ineligibleChildren, setIneligibleChildren] = useState([]);

  const handleChildToggle = (id) => {
    setIneligibleChildren((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
    );
  };
  const maskNric = (nric) => {
    if (!nric) return "";
    return "*****" + nric.slice(-4);
  };
  const resetState = () => {
    setEligibility("");
    setUndertaking(false);
    setIneligibleChildren([]);
  };
  const canSubmit =
    (eligibility === "1" && undertaking) ||
    (eligibility === "2" && undertaking && ineligibleChildren.length > 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle><b>Declaration of Child(ren) Dependant(s) Status</b></DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          gutterBottom
          align="justify"
          style={{ marginBottom: "20px" }}
        >
          Please declare that your child(ren) who is/are between{" "}
          <u>18 years old and less than 25 years old</u> as of 1 Jan next year{" "}
          is/are currently unmarried, unemployed, is/are not enlisted for{" "}
          <b>AND</b> is/are not serving full-time National Service under
          Enlistment Act in Singapore.
        </Typography>

        <RadioGroup
          value={eligibility}
          onChange={(e) => {
              const value = e.target.value;
              setEligibility(value);

              if (value === "1") {
                setIneligibleChildren([]); // clear all checkbox selections
                setUndertaking(false);     // uncheck the undertaking declaration
              }
            }}
        >
          <Box mb={2}>
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="I declare that my child(ren) meet(s) the eligibility criteria stated above and is/are therefore eligible for coverage under the group medical insurance plan."
              style={{ marginLeft: "32px", alignItems: "flex-start" }}
            />
          </Box>

          <Box mb={2}>
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="No, one or more of my child(ren) do(es) not meet the above-mentioned criteria and is/are not an eligible dependant(s) to be covered under Group Medical Insurance. The following selected child(ren) do(es) not meet the criteria and should be removed from Group Medical Insurance:"
              style={{ marginLeft: "32px", alignItems: "flex-start" }}
            />
          </Box>
        </RadioGroup>
        {eligibility === "2" && (
          <FormGroup style={{ marginLeft: "32px", marginBottom: "20px" }}>
              {childDependencies.map(dep => (
                <FormControlLabel
                  key={dep.id}
                  control={
                    <Checkbox
                      checked={ineligibleChildren.includes(dep.id)}
                      onChange={() => handleChildToggle(dep.id)}
                    />
                  }
                  label={`${dep.full_name || dep.first_name || "Unnamed"} ${maskNric(dep.id_no)}`}
                  style={{ marginLeft: "32px", alignItems: "flex-start" }}
                />
              ))}
            </FormGroup>
        )}

        <Box mb={2}>
          <FormControlLabel
            control={
              <Radio
                checked={undertaking}
                onChange={() => setUndertaking(true)}
              />
            }
            label="I hereby undertake to inform HR team via SGP.Rewards@prudential.com.sg in the event that the status of my child(ren) changes to married, employed or becomes enlisted for full-time NS. Additionally, it is acknowledged that Prudential reserves the right to make void this enrolment if it is determined to be falsely declared and/or there is an omission in updating the status of my child(ren)."
          />
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "flex-end", padding: "16px 24px" }}>
        <Button
          onClick={() => {
              resetState();
              onClose();
            }}
          color="primary"
          variant="outlined"
          style={{
            backgroundColor: "#ED1C24",
            color: "#fff",
            fontWeight: "bold",
            marginRight: "12px"
          }}
        >
          Cancel
        </Button>

        <Button
            onClick={() => {
                onSubmit(ineligibleChildren);
                resetState();  
              }}
          color="primary"
          variant="contained"
          disabled={!canSubmit}
          style={{
            backgroundColor: canSubmit ? "#ED1C24" : "#ccc",
            color: "#fff",
            fontWeight: "bold"
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeclarationModal;
